import styled from "styled-components";
import { useState } from "react";
import { FaSearch } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

function Search() {
  const [input, setInput] = useState("");
  const navigate = useNavigate();

  const submitHandler = (e) => {
    e.preventDefault();
    navigate("/searched/" + input);
  };

  return (
    <FormStyle onSubmit={submitHandler}>
      <div>
        {input.length <= 0 && <FaSearch />}
        <input
          onChange={(e) => setInput(e.target.value)}
          type="text"
          value={input}
        />
      </div>
    </FormStyle>
  );
}

const FormStyle = styled.form`
  @media (max-width: 768px) {
    width: 80%;
    align-items: center;
    margin: auto;
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    width: 80%;
    align-items: center;
    margin: auto;
  }

  div {
    width: 70%;
    position: relative;
    margin: auto;
  }

  input {
    border: none;
    background: linear-gradient(35deg, #494949, #313131);
    font-size: 1.5rem;
    color: white;
    padding: 1rem 1rem;
    border: none;
    border-radius: 1rem;
    outline: none;
    width: 100%;
    margin: 0;

    @media (max-width: 768px) {
      padding: 0.4rem 0rem;
      font-size: 1.2rem;
      text-align: center;
    }

    @media (min-width: 768px) and (max-width: 1024px) {
      padding: 0.8rem 0rem;

      font-size: 1.4rem;
    }
  }

  svg {
    position: absolute;
    top: 50%;
    left: 0%;
    transform: translate(100%, -50%);
    color: white;
  }
`;

export default Search;
